const GameEndReturnVector = (props) => {
  return (
    <svg
      width={23}
      height={16}
      fill="current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.9 4.9a.7.7 0 111.4 0V7h2.1a.7.7 0 110 1.4H7.3v2.1a.7.7 0 11-1.4 0V8.4H3.8a.7.7 0 010-1.4h2.1V4.9zm12.6.7a1.4 1.4 0 11-2.8 0 1.4 1.4 0 012.8 0zm-4.2 5.6a1.4 1.4 0 100-2.8 1.4 1.4 0 000 2.8zM.3 7.7A7.7 7.7 0 018 0h7a7.7 7.7 0 110 15.4H8A7.7 7.7 0 01.3 7.7zM8 1.4A6.3 6.3 0 108 14h7a6.3 6.3 0 000-12.6H8z"
        fill="current"
      />
    </svg>
  );
};

export default GameEndReturnVector;
